import React, { useState } from 'react';
import Layout from '../../components/global/layout';
import Pagination from 'react-pagination-js';
import './style.scss';
import methodModel from '../../methods/methods';
import datepipeModel from '../../models/datepipemodel';
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Tooltip } from 'antd';
import { HiOutlineArrowDown } from 'react-icons/hi';
import { FiEdit3, FiPlus } from 'react-icons/fi';
import { BsTrash3 } from 'react-icons/bs';
import { PiFileCsv } from 'react-icons/pi';
import SelectDropdown from '../../components/common/SelectDropdown';
import statusModel from '../../models/status.model';
import View from '../Events/View';
import { FaEye } from 'react-icons/fa';
import { HiArrowSmUp } from 'react-icons/hi';

const Html = ({
  sortClass,
  sorting,
  type,
  add,
  edit,
  ChangeRole,
  UpdateStatus,
  pageChange,
  deleteItem,
  exportfun,
  filters,
  view,
  loaging,
  data,
  statuschange,
  reset,
  cattype,
  dynamicStyle = false,
  className = null,
  total,
  dragStart,
  dragEnter,
  drop,
  dargEnterIndex,
  dargIndex,
  isAllow,
  showData,
  setFilter,
  getData,
}) => {
  const renderSortIcon = (columnKey) => {
    if (filters.key !== columnKey)
      return <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
    else {
      if (filters.sorder === 'asc') {
        <HiArrowSmUp className="shrink-0 inline text-sm" />;
      } else {
        <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
      }
    }
    return filters.sorder === 'asc' ? (
      <HiArrowSmUp className="shrink-0 inline text-sm" />
    ) : (
      <HiOutlineArrowDown className="shrink-0 inline text-sm" />
    );
  };
  console.log(data, '2222222222');
  const [status, setstatus] = useState('');
  const handleItemCountChange = (e) => {
    setFilter({ ...filters, page: 1, count: e?.target?.value });
    getData({ page: 1, count: e?.target?.value });
  };
  const TableRow = ({ itm, className, index, parentCategory }) => {
    return (
      <tr
        className={` ${className || ''} ${dargIndex == index ? 'dragStart' : ''
          } ${dargEnterIndex == index ? 'dragEnter' : ''}`}
        onDragStart={(e) => dragStart(e, index)}
        onDragEnter={(e) => dragEnter(e, index)}
        onDragEnd={(e) => drop(e)}
        key={index}
        draggable={parentCategory ? false : true}
      >
        <td
          className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]"
        >
          {' '}
          <div className="user_detail cursor-pointer" onClick={(e) => edit(itm.id)}>
            <img
              src={
                itm.image
                  ? methodModel.userImg(itm.image)
                  : methodModel.noImg(itm.banner)
              }
              className="cat_img"
            />
          </div>
        </td>
        <td className="!text-typo !border-l-0!px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0] capitalize">
          {itm.name || '--'}
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          {itm.parentCategory?.name || '--'}
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          {itm.catType?.name}
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          {datepipeModel.date(itm.createdAt)}
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          {datepipeModel.date(itm.updatedAt)}
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          {itm?.updatedBy?.fullName || '--'}
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          {' '}
          <div
            className={`user_hours ${itm.status}`}
            onClick={() => statuschange(itm)}
          >
            <Tooltip
              placement="top"
              title={itm.status === 'active' ? 'Deactive' : 'Active'}
            >
              <span
                className={`text-sm !px-3 h-[30px] flex items-center justify-center border border-[#EBEBEB]  text-white !rounded capitalize ${itm.status === 'active' ? 'bg-[#1c2b35]' : 'bg-[#A12238] '
                  }`}
              >
                {itm.status == 'deactive' ? 'Inactive' : 'Active'}
              </span>
            </Tooltip>
          </div>
        </td>
        <td className="!text-typo !border-l-0 cursor-pointer !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          <div className="flex items-center gap-1.5">
            {isAllow('blog_edit') ? (
              <Tooltip placement="top" title="Edit">
                <a
                  className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                  title="Edit"
                  onClick={(e) => edit(itm.id)}
                >
                  <FiEdit3 />
                </a>
              </Tooltip>
            ) : (
              <></>
            )}
            {isAllow('blog_delete') ? (
              <Tooltip placement="top" title="Delete">
                <span
                  className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md "
                  onClick={() => deleteItem(itm.id)}
                >
                  <BsTrash3 />
                </span>
              </Tooltip>
            ) : (
              <></>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <Layout>
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-2xl font-semibold text-[#111827]">
            {type ? 'Reseller' : ''} Recommended Products
          </h3>
          <p class="text-sm font-normal text-[#525252]">
            Here you can see all about your Recommended Products
          </p>
        </div>

        <div className="flex filterFlex phSpace">
          {isAllow('blog_add') ? (
            <a
              className="bg-primary leading-10 mr-3 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg gap-2"
              onClick={(e) => add()}
            >
              <FiPlus className="text-xl text-white" /> Add{' '}
              {type ? 'Reseller' : ''} Recommended Product
            </a>
          ) : (
            <></>
          )}
        </div>
      </div>

      <div className="shadow-lg w-full bg-white rounded-lg mt-6">
        <div className="flex items-center justify-end p-4 gap-2">
          {!type ? (
            <>
              <SelectDropdown
                id="statusDropdown"
                displayValue="name"
                placeholder="All Type"
                intialValue={filters.category_id}
                result={(e) => {
                  ChangeRole(e.value);
                }}
                options={cattype}
                theme="search"
              />
            </>
          ) : (
            <></>
          )}

          <SelectDropdown
            id="statusDropdown"
            displayValue="name"
            placeholder="All Status"
            intialValue={filters.status}
            result={(e) => {
              statuschange(e.value);
            }}
            options={statusModel.list}
            theme="search"
          />
          {filters.search ||
            filters.parentCategory ||
            filters.status ||
            (filters.catType && !type) ? (
            <>
              <a
                className="bg-primary leading-10 h-10 shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg mr-2"
                onClick={(e) => reset()}
              >
                Reset
              </a>
            </>
          ) : (
            <></>
          )}
        </div>

        <div className="scrollbar w-full overflow-auto">
          <table class="w-full">
            <thead className="text-xs text-gray-700 capitalize bg-gray-50  border-b border-[#EAECF0]">
              <tr className="border-b border-[#EAECF0]">
                <th
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap "
                  onClick={(e) => sorting('title')}
                >
                  Title <span className="mr-2">{renderSortIcon('title')}</span>
                </th>

                <th
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                  onClick={(e) => sorting('category_name')}
                >
                  Category Type{' '}
                  <span className="mr-2">
                    {renderSortIcon('category_name')}
                  </span>
                </th>
                <th
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                  onClick={(e) => sorting('createdAt')}
                >
                  Date Created{' '}
                  <span className="mr-2">{renderSortIcon('createdAt')}</span>
                </th>
                <th
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                  onClick={(e) => sorting('updatedAt')}
                >
                  Last Modified{' '}
                  <span className="mr-2">{renderSortIcon('updatedAt')}</span>
                </th>

                <th
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                >
                  Status
                </th>
                <th
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody id="tableBodycat">
              {!loaging &&
                data &&
                data?.map((itm, i) => {
                  return (
                    <tr className="capitalize">
                      <td
                        className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]"
                      >
                        <Tooltip placement="right" title="View">
                          <div className="user_detail" onClick={(e) => view(itm.id)}>
                            <div className="user_name">
                              <h4 className="user">
                                {methodModel.capitalizeFirstLetter(itm?.title)}
                              </h4>
                            </div>
                          </div>
                        </Tooltip>
                      </td>

                      <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                        {itm?.category_id?.name}
                      </td>

                      {/* <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                          {datepipeModel.date(itm.lastLogin)}
                        </td> */}

                      <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                        {datepipeModel.date(itm.createdAt)}
                      </td>
                      <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                        {datepipeModel.date(itm.updatedAt)}
                      </td>
                      <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                        <div onClick={() => UpdateStatus(itm)}>
                          {/* <Tooltip placement="top" title="Active / Inactive"> */}
                          <span
                            className={`${itm.status == 'deactive'
                                ? 'bg-[#A12238] text-[#fff]'
                                : 'bg-[#1c2b35] text-white'
                              } text-sm w-[100px] !px-3 h-[30px] cursor-pointer flex items-center justify-center border border-[#EBEBEB] !rounded`}
                          >
                            {itm.status == 'deactive' ? 'Inactive' : 'Active'}
                          </span>
                          {/* </Tooltip> */}
                        </div>
                      </td>
                      {/* <td className='!text-typo !border-l-0 cursor-pointer !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]'>{datepipeModel.date(itm.updatedAt)}</td> */}

                      {/* dropdown */}
                      <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]">
                        <div className="flex items-center gap-1.5">
                          {isAllow('blog_get') ? (
                            <>
                              <Tooltip placement="top" title="View">
                                <a
                                  className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                  onClick={(e) => view(itm.id)}
                                >
                                  <FaEye />
                                </a>
                              </Tooltip>
                            </>
                          ) : (
                            <></>
                          )}
                          {isAllow('blog_edit') ? (
                            <>
                              <Tooltip placement="top" title="Edit">
                                <a
                                  className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                  title="Edit"
                                  onClick={(e) => edit(itm?.id)}
                                >
                                  <FiEdit3 />
                                </a>
                              </Tooltip>
                            </>
                          ) : (
                            <></>
                          )}

                          {isAllow('blog_delete') ? (
                            <>
                              <Tooltip placement="top" title="Delete">
                                <span
                                  className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                  onClick={() => deleteItem(itm.id)}
                                >
                                  <BsTrash3 />
                                </span>
                              </Tooltip>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {/* {!loaging &&
                data &&
                showData().map((itm, i) => {
                  return (
                    <>
                      <TableRow itm={itm} index={i} />
                      {itm?.childCategories &&
                        itm?.childCategories.map((citm) => {
                          return (
                            <>
                              <TableRow
                                itm={{ ...citm, id: citm._id }}
                                index={i}
                                className="subCategory"
                                parentCategory={itm}
                              />
                              {citm.childCategories &&
                                citm.childCategories.map((sitm) => {
                                  return (
                                    <TableRow
                                      itm={{ ...sitm, id: citm._id }}
                                      index={i}
                                      className="subSubCategory"
                                      parentCategory={citm}
                                    />
                                  );
                                })}
                            </>
                          );
                        })}
                    </>
                  );
                })} */}
            </tbody>
          </table>
        </div>

        {!loaging && total == 0 ? (
          <div className="py-3 text-center text-[#8b8b8b]">No Data</div>
        ) : (
          <></>
        )}
        {!loaging && total > 10 ? (
          <div className="paginationWrapper  mt-15">
            <span className='text-sm text-gray-600'>Show {filters.count} from {total} Blogs</span>
            <select
              className="border-[1px] border-[#cfd5dc] rounded-[5px] px-[5px] py-[5px] bg-white text-[12px] mr-3"
              value={filters.count} // Current value of items per page
              onChange={(e) => handleItemCountChange(e)} // Function to handle changes
            >
              {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>

            <Pagination
              currentPage={filters.page}
              totalSize={total}
              sizePerPage={filters.count}
              changeCurrentPage={pageChange}
            />

          </div>
        ) : (
          <></>
        )}
        {loaging ? (
          <div className="text-center py-4">
            <img src="/assets/img/loader.gif" className="pageLoader" />
          </div>
        ) : (
          <></>
        )}
      </div>
    </Layout>
  );
};

export default Html;
